import React from 'react'

function PerformanceDashboard() {
  const url = 'https://console.firebase.google.com/u/2/'; 
  window.open(url);
  window.history.back();
  return (
    <></>
  )
}

export default PerformanceDashboard